// importing stuff
import { NgModule, ErrorHandler } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler, DeepLinkConfig } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { Deeplinks } from '@ionic-native/deeplinks';
import { HttpModule } from '@angular/http';
import { LocationStrategy,PathLocationStrategy,APP_BASE_HREF } from '@angular/common';
import * as Clipboard from 'clipboard/dist/clipboard.min.js';

// importing providers
import { User } from '../providers/user';
import { Task } from '../providers/task';
import { Admob } from '../providers/admob';
import { Fb } from '../providers/firebase';

// importing pages
import { AboutPage } from '../pages/about/about';
import { TutorialPage } from '../pages/tutorial/tutorial';
import { AccountPage } from '../pages/account/account';
import { AccountEmailPage } from '../pages/account-email/account-email';
import { AccountPasswordPage } from '../pages/account-password/account-password';
import { AccountNamePage } from '../pages/account-name/account-name';
import { AccountLoginPage } from '../pages/account-login/account-login';
import { AccountSignupPage } from '../pages/account-signup/account-signup';
import { AccountForgotPage } from '../pages/account-forgot/account-forgot';
import { HomePage } from '../pages/home/home';
import { PublicPage } from '../pages/public/public';

// importing components
import { FiretaskApp } from './app.component';
import { AccountLoginFormComponent } from '../components/account-login-form/account-login-form';
import { AccountLoginSocialComponent } from '../components/account-login-social/account-login-social';
import { AccountSignupFormComponent } from '../components/account-signup-form/account-signup-form';
import { AccountForgotFormComponent } from '../components/account-forgot-form/account-forgot-form';
import { AccountManagerComponent } from '../components/account-manager/account-manager';
import { AccountAvatarComponent } from '../components/account-avatar/account-avatar';
import { AccountNameFormComponent } from '../components/account-name-form/account-name-form';
import { AccountEmailFormComponent } from '../components/account-email-form/account-email-form';
import { AccountPasswordFormComponent } from '../components/account-password-form/account-password-form';
import { AccountPhotoManager } from '../components/account-photo-manager/account-photo-manager';
import { AppHeaderComponent } from '../components/app-header/app-header';
import { AppMenuComponent } from '../components/app-menu/app-menu';
import { AppHeaderPopoverComponent, AppHeaderPopoverController } from '../components/app-header-popover/app-header-popover';
import { TasksComponent } from '../components/tasks/tasks';
import { TasksDetailComponent } from '../components/tasks-detail/tasks-detail';
import { TasksCommentComponent } from '../components/tasks-comment/tasks-comment';
import { VoucherComponent } from '../components/voucher/voucher';


export const deepLinkConfig: DeepLinkConfig = {
  links: [
    { component: AccountSignupPage, name: 'Signup', segment: 'signup' },
//    { component: PublicPage, name: 'Public', segment: ':id' },
    { component: HomePage, name: 'Home', segment: 'home' },
    { component: TasksDetailComponent, name: 'New', segment: 'new' },
    { component: TasksCommentComponent, name: 'Voucher', segment: 'voucher' },
    { component: AccountPage, name: 'Account', segment: 'account' }
  ]
};

@NgModule({
    declarations: [
        FiretaskApp,
        AboutPage,
        TutorialPage,
        AccountPage,
        AccountEmailPage,
        AccountPasswordPage,
        AccountNamePage,
        AccountLoginPage,
        AccountSignupPage,
        AccountForgotPage,
        HomePage,     
        PublicPage, 
        AccountLoginFormComponent,
        AccountLoginSocialComponent,
        AccountSignupFormComponent,
        AccountForgotFormComponent,
        AccountManagerComponent,
        AccountAvatarComponent,
        AccountNameFormComponent,
        AccountEmailFormComponent,
        AccountPasswordFormComponent,
        AccountPhotoManager,
        AppHeaderComponent,
        AppMenuComponent,
        AppHeaderPopoverComponent,
        TasksComponent,
        TasksDetailComponent,
        TasksCommentComponent,
        VoucherComponent
    ],
    imports: [
        HttpModule,
        IonicModule.forRoot(FiretaskApp, { }, deepLinkConfig)//locationStrategy: 'path' 
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        FiretaskApp,
        AboutPage,
        TutorialPage,
        AccountPage,
        AccountEmailPage,
        AccountPasswordPage,
        AccountNamePage,
        AccountLoginPage,
        AccountSignupPage,
        AccountForgotPage,
        HomePage,
        PublicPage,
        AccountLoginFormComponent,
        AccountLoginSocialComponent,
        AccountSignupFormComponent,
        AccountForgotFormComponent,
        AccountManagerComponent,
        AccountAvatarComponent,
        AccountNameFormComponent,
        AccountEmailFormComponent,
        AccountPasswordFormComponent,
        AccountPhotoManager,
        AppHeaderComponent,
        AppMenuComponent,
        AppHeaderPopoverComponent,
        TasksComponent,
        TasksDetailComponent,
        TasksCommentComponent,
        VoucherComponent
    ],
    providers: [Storage, Admob, User, Task, Fb, AppHeaderPopoverController, Deeplinks, {provide: ErrorHandler, useClass: IonicErrorHandler}]// {provide: LocationStrategy, useClass: PathLocationStrategy}, {provide: APP_BASE_HREF, useValue: '/'}
})
export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts